import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Label } from "@/components/ui/label";

/**
 * Tendina del committente per la scheda cantiere.
 *
 * Il nome esteso lo scrive il server partendo dall'id scelto qui, quindi al
 * modulo basta portarsi dietro `client_id`. Un cantiere vecchio puo' avere un
 * committente scritto a mano e non ancora collegato: in quel caso la dicitura
 * resta visibile in fondo alla tendina, cosi' non sparisce sotto gli occhi di
 * chi sta modificando altro. Si sistema da Cantieri > Committenti.
 */
export default function SceltaCommittente({ value, testo, onChange }) {
  const [committenti, setCommittenti] = useState([]);

  useEffect(() => {
    api.get("/committenti").then(({ data }) => setCommittenti(data)).catch(() => {});
  }, []);

  const scollegato = !value && testo;

  return (
    <div>
      <Label>Cliente / Committente</Label>
      <select className="w-full h-10 border border-slate-200 rounded px-3 mt-1"
              value={value || ""} onChange={(e) => onChange(e.target.value || null)}
              data-testid="scelta-committente">
        <option value="">— nessuno —</option>
        {committenti.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
        {scollegato && <option value="" disabled>{`(oggi: ${testo})`}</option>}
      </select>
      {scollegato && (
        <p className="text-[11px] text-amber-700 mt-1">
          Scritto a mano come <b>{testo}</b> e non ancora collegato all'anagrafica.
          Si sistema dal pulsante <b>Committenti</b> in Cantieri.
        </p>
      )}
      {committenti.length === 0 && (
        <p className="text-[11px] text-slate-500 mt-1">
          Nessun committente in anagrafica: aggiungili dal pulsante <b>Committenti</b>.
        </p>
      )}
    </div>
  );
}
